// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids List Box Component */
:host {
  color: var(--ids-dropdown-color-text-default);
  cursor: var(--ids-cursor-pointer);
  display: block;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  font-size: 16px;
  line-height: 32px;
  outline: none;
  min-height: 32px;
  padding: 0;
  text-indent: 8px;
  user-select: none;
  min-width: calc(var(--ids-input-width-10) - 2px);
  text-overflow: ellipsis;
  overflow: clip;
  width: 100%;
  white-space: nowrap;
}

:host(.multiselect-option),
:host(.icon-option) {
  display: flex;
}
:host(.multiselect-option) ::slotted(ids-icon),
:host(.icon-option) ::slotted(ids-icon) {
  margin: 0;
  margin-inline-start: var(--ids-dropdown-space-text);
}

:host(.multiselect-loaded) {
  align-items: center;
}
:host(.multiselect-loaded) ::slotted(ids-text) {
  position: relative;
  top: 1px;
  min-width: 70px;
}

:host([disabled]:not([disabled=false])) {
  cursor: var(--ids-cursor-default);
  opacity: 0.5;
  pointer-events: none;
}

:host(.is-selected:not(.multiselect-option)) {
  background-color: var(--ids-dropdown-color-background-selected);
  color: var(--ids-dropdown-color-text-selected);
  position: relative;
  z-index: 1;
}

:host(:hover:not(.is-selected):not([group-label]):not([no-results]):not(.multiselect-option)),
:host(.is-focused),
:host(.multiselect-option:focus),
:host(.multiselect-option.is-selected),
:host(.multiselect-option:hover) {
  background-color: var(--ids-dropdown-color-background-hover);
  position: relative;
  z-index: 0;
}

::slotted(ids-icon) {
  vertical-align: middle;
  margin: 0 var(--ids-dropdown-space-text) 2px 0;
}

::slotted(ids-avatar) {
  text-indent: 0;
  margin-inline-end: 8px;
}

::slotted(ids-icon[dir=rtl]) {
  margin: 0 0 2px var(--ids-dropdown-space-text);
}

::slotted(ids-color) {
  vertical-align: middle;
  margin-inline-end: var(--ids-dropdown-space-text);
  position: relative;
  top: -1.5px;
}

::slotted(ids-checkbox), ::slotted(ids-checkbox.multiselect-loaded) {
  flex: 0 0 auto;
  min-width: 0;
  padding-inline-start: 11px;
  line-height: 19px;
  position: relative;
}

::slotted(ids-checkbox[label]) {
  width: 100%;
}

::slotted(ids-checkbox.multiselect-loaded) {
  top: 1px;
}

::slotted(.highlight) {
  display: contents;
  font-weight: var(--ids-font-weight-bold);
}

::slotted([slot=info]) {
  font-size: 12px;
  display: block;
  line-height: normal;
  padding-bottom: 8px;
  margin-top: -3px;
}

:host(.multi-column-option) {
  display: table-row;
}
:host(.multi-column-option) ::slotted(span.multi-key) {
  display: table-cell;
}

:host(.multi-column) {
  display: table-row;
  box-sizing: border-box;
}
:host(.multi-column) ::slotted(span.multi-key) {
  display: table-cell;
  box-sizing: border-box;
  padding-inline: 8px;
}

:host([group-label]) {
  cursor: var(--ids-cursor-default);
  color: var(--ids-dropdown-group-color-text);
  font-weight: var(--ids-font-weight-semibold);
}

:host([group-label]:not(:first-child)),
:host(.multiselect-border) {
  border-top: 1px solid var(--ids-dropdown-group-color-border);
  margin-top: var(--ids-dropdown-group-padding);
}

:host(.module-nav) {
  color: var(--ids-module-nav-settings-menu-item-text-color);
  min-height: var(--ids-module-nav-item-height);
  line-height: var(--ids-module-nav-item-height);
  padding-block: var(--ids-module-nav-switcher-dropdown-item-margin-block);
  position: relative;
  border-left: 4px solid transparent;
  transition: background-color 0.2s ease, border-left-color 0.2s ease;
  margin-bottom: 2px;
  border-radius: 0;
}

:host(.module-nav) ::slotted(ids-icon) {
  margin-inline-end: 8px;
  margin-block-end: 1px;
}

:host(.module-nav:hover) {
  background-color: var(--ids-module-nav-item-hover-bg-color);
  color: var(--ids-module-nav-item-hover-text-color);
}

:host(.module-nav.is-selected) {
  background-color: var(--ids-module-nav-item-hover-bg-color);
  color: var(--ids-module-nav-item-hover-text-color);
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-list-box/ids-list-box-option.scss"],"names":[],"mappings":"AAAA,2BAAA;AACA;EACE,6CAAA;EACA,iCAAA;EACA,cAAA;EACA,+EAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,gDAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,aAAA;AACF;AACE;;EACE,SAAA;EACA,mDAAA;AAEJ;;AAEA;EACE,mBAAA;AACF;AACE;EACE,kBAAA;EACA,QAAA;EACA,eAAA;AACJ;;AAGA;EACE,iCAAA;EACA,YAAA;EACA,oBAAA;AAAF;;AAGA;EACE,+DAAA;EACA,8CAAA;EACA,kBAAA;EACA,UAAA;AAAF;;AAGA;;;;;EAKE,4DAAA;EACA,kBAAA;EACA,UAAA;AAAF;;AAIA;EACE,sBAAA;EACA,8CAAA;AADF;;AAIA;EACE,cAAA;EACA,sBAAA;AADF;;AAIA;EACE,8CAAA;AADF;;AAIA;EACE,sBAAA;EACA,iDAAA;EACA,kBAAA;EACA,WAAA;AADF;;AAIA;EACE,cAAA;EACA,YAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,QAAA;AADF;;AAIA;EACE,iBAAA;EACA,wCAAA;AADF;;AAIA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;AADF;AAGE;EACE,mBAAA;AADJ;;AAKA;EACE,kBAAA;EACA,sBAAA;AAFF;AAIE;EACE,mBAAA;EACA,sBAAA;EACA,mBAAA;AAFJ;;AAOA;EACE,iCAAA;EACA,2CAAA;EACA,4CAAA;AAJF;;AAOA;;EAEE,4DAAA;EACA,6CAAA;AAJF;;AAOA;EACE,0DAAA;EACA,6CAAA;EACA,8CAAA;EACA,wEAAA;EACA,kBAAA;EACA,kCAAA;EACA,mEAAA;EACA,kBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,sBAAA;EACA,qBAAA;AAJF;;AAOA;EACE,2DAAA;EACA,kDAAA;AAJF;;AAOA;EACE,2DAAA;EACA,kDAAA;EACA,UAAA;AAJF","sourcesContent":["/* Ids List Box Component */\n:host {\n  color: var(--ids-dropdown-color-text-default);\n  cursor: var(--ids-cursor-pointer);\n  display: block;\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  font-size: 16px;\n  line-height: 32px;\n  outline: none;\n  min-height: 32px;\n  padding: 0;\n  text-indent: 8px;\n  user-select: none;\n  min-width: calc(var(--ids-input-width-10) - 2px);\n  text-overflow: ellipsis;\n  overflow: clip;\n  width: 100%;\n  white-space: nowrap;\n}\n\n:host(.multiselect-option),\n:host(.icon-option) {\n  display: flex;\n\n  ::slotted(ids-icon) {\n    margin: 0;\n    margin-inline-start: var(--ids-dropdown-space-text);\n  }\n}\n\n:host(.multiselect-loaded) {\n  align-items: center;\n\n  ::slotted(ids-text) {\n    position: relative;\n    top: 1px;\n    min-width: 70px;\n  }\n}\n\n:host([disabled]:not([disabled='false'])) {\n  cursor: var(--ids-cursor-default);\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n:host(.is-selected:not(.multiselect-option)) {\n  background-color: var(--ids-dropdown-color-background-selected);\n  color: var(--ids-dropdown-color-text-selected);\n  position: relative;\n  z-index: 1;\n}\n\n:host(:hover:not(.is-selected):not([group-label]):not([no-results]):not(.multiselect-option)),\n:host(.is-focused),\n:host(.multiselect-option:focus),\n:host(.multiselect-option.is-selected),\n:host(.multiselect-option:hover) {\n  background-color: var(--ids-dropdown-color-background-hover);\n  position: relative;\n  z-index: 0;\n}\n\n// Style Icons when in the list\n::slotted(ids-icon) {\n  vertical-align: middle;\n  margin: 0 var(--ids-dropdown-space-text) 2px 0;\n}\n\n::slotted(ids-avatar) {\n  text-indent: 0;\n  margin-inline-end: 8px;\n}\n\n::slotted(ids-icon[dir='rtl']) {\n  margin: 0 0 2px var(--ids-dropdown-space-text);\n}\n\n::slotted(ids-color) {\n  vertical-align: middle;\n  margin-inline-end: var(--ids-dropdown-space-text);\n  position: relative;\n  top: -1.5px;\n}\n\n::slotted(ids-checkbox), ::slotted(ids-checkbox.multiselect-loaded) {\n  flex: 0 0 auto;\n  min-width: 0;\n  padding-inline-start: 11px;\n  line-height: 19px;\n  position: relative;\n}\n\n::slotted(ids-checkbox[label]) {\n  width: 100%;\n}\n\n::slotted(ids-checkbox.multiselect-loaded) {\n  top: 1px;\n}\n\n::slotted(.highlight) {\n  display: contents;\n  font-weight: var(--ids-font-weight-bold);\n}\n\n::slotted([slot='info']) {\n  font-size: 12px;\n  display: block;\n  line-height: normal;\n  padding-bottom: 8px;\n  margin-top: -3px;\n}\n\n:host(.multi-column-option) {\n  display: table-row;\n\n  ::slotted(span.multi-key) {\n    display: table-cell;\n  }\n}\n\n:host(.multi-column) {\n  display: table-row;\n  box-sizing: border-box;\n\n  ::slotted(span.multi-key) {\n    display: table-cell;\n    box-sizing: border-box;\n    padding-inline: 8px;\n  }\n}\n\n// Group labels\n:host([group-label]) {\n  cursor: var(--ids-cursor-default);\n  color: var(--ids-dropdown-group-color-text);\n  font-weight: var(--ids-font-weight-semibold);\n}\n\n:host([group-label]:not(:first-child)),\n:host(.multiselect-border) {\n  border-top: 1px solid var(--ids-dropdown-group-color-border);\n  margin-top: var(--ids-dropdown-group-padding);\n}\n\n:host(.module-nav) {\n  color: var(--ids-module-nav-settings-menu-item-text-color);\n  min-height: var(--ids-module-nav-item-height);\n  line-height: var(--ids-module-nav-item-height);\n  padding-block: var(--ids-module-nav-switcher-dropdown-item-margin-block);\n  position: relative;\n  border-left: 4px solid transparent;\n  transition: background-color 0.2s ease, border-left-color 0.2s ease;\n  margin-bottom: 2px;\n  border-radius: 0;\n}\n\n:host(.module-nav) ::slotted(ids-icon) {\n  margin-inline-end: 8px;\n  margin-block-end: 1px;\n}\n\n:host(.module-nav:hover) {\n  background-color: var(--ids-module-nav-item-hover-bg-color);\n  color: var(--ids-module-nav-item-hover-text-color);\n}\n\n:host(.module-nav.is-selected) {\n  background-color: var(--ids-module-nav-item-hover-bg-color);\n  color: var(--ids-module-nav-item-hover-text-color);\n  z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
